import { Card, Form } from "react-bootstrap";
import { useQuery, useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useState } from "react";

import { GET_DIGITAL_WALLET } from "../../graphql/queries/digitalWallet";

import { UPDATE_DIGITAL_WALLET } from "../../graphql/mutations/digitalWallet";

import { showErrorToast } from "../../components/common/CustomErrorMessage";
import SubmitButton from "../../components/common/SubmitButton";
import CustomFormGroupWithSwitch from "../../components/form/CustomFormGroupWithSwitch";

const DigitalWalletPage = () => {
  const [formData, setFormData] = useState({
    btc: {
      address: { address: "", isActive: true },
      address_omni: { address: "", isActive: true },
      address_erc20: { address: "", isActive: true },
    },
    usdt: {
      address: { address: "", isActive: false },
      address_erc20: { address: "", isActive: true },
      address_omni: { address: "", isActive: true },
    },
  });
  const [walletId, setWalletId] = useState(null);

  const { loading: walletLoading } = useQuery(GET_DIGITAL_WALLET, {
    fetchPolicy: "network-only",
    onCompleted(data) {
      if (data.digitalWallet) {
        const wallet = data.digitalWallet;
        setWalletId(wallet.id);
        setFormData({
          btc: {
            address: {
              address: wallet.btc?.address?.address || "",
              isActive: wallet.btc?.address?.isActive || false,
            },
            address_omni: {
              address: wallet.btc?.address_omni?.address || "",
              isActive: wallet.btc?.address_omni?.isActive || false,
            },
            address_erc20: {
              address: wallet.btc?.address_erc20?.address || "",
              isActive: wallet.btc?.address_erc20?.isActive || false,
            },
          },
          usdt: {
            address: {
              address: wallet.usdt?.address?.address || "",
              isActive: wallet.usdt?.address?.isActive || false,
            },
            address_erc20: {
              address: wallet.usdt?.address_erc20?.address || "",
              isActive: wallet.usdt?.address_erc20?.isActive || false,
            },
            address_omni: {
              address: wallet.usdt?.address_omni?.address || "",
              isActive: wallet.usdt?.address_omni?.isActive || false,
            },
          },
        });
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const [updateDigitalWallet, { loading: updateLoading }] = useMutation(
    UPDATE_DIGITAL_WALLET,
    {
      refetchQueries: [{ query: GET_DIGITAL_WALLET }],
      onCompleted: (data) => {
        if (data.updateDigitalWallet) {
          toast.success(`ອັບເດດກະເປົາເງິນດິຈິຕອນສຳເລັດແລ້ວ`, {
            position: "top-center",
            autoClose: 3000,
            className: "lao",
          });
        }
      },
      onError(err) {
        showErrorToast(err.message);
      },
    },
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    const [currency, addressType, field] = name.split(".");
    setFormData((prev) => ({
      ...prev,
      [currency]: {
        ...prev[currency],
        [addressType]: {
          ...prev[currency][addressType],
          [field]: value,
        },
      },
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    const [currency, addressType, field] = name.split(".");
    setFormData((prev) => ({
      ...prev,
      [currency]: {
        ...prev[currency],
        [addressType]: {
          ...prev[currency][addressType],
          [field]: checked,
        },
      },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!walletId) {
      toast.error("ບໍ່ພົບຂໍ້ມູນກະເປົາເງິນດິຈິຕອນ", {
        position: "top-center",
        className: "lao",
      });
      return;
    }
    updateDigitalWallet({
      variables: {
        id: walletId,
        input: formData,
      },
    });
  };

  return (
    <div className="lao">
      <Card>
        <Card.Header>
          <Card.Title>
            <h3 className="p-1">ຈັດການກະເປົາເງິນດິຈິຕອນ</h3>
          </Card.Title>
        </Card.Header>
        <Card.Body>
          {walletLoading ? (
            <div className="text-center">ກຳລັງໂຫຼດ..</div>
          ) : (
            <Form className="notolao" onSubmit={handleSubmit}>
              {/* BTC Section */}
              <h5 className="mb-3 lao">Bitcoin (BTC)</h5>
              <CustomFormGroupWithSwitch
                label="BTC Address"
                inputName="btc.address.address"
                switchName="btc.address.isActive"
                onChange={handleChange}
                onSwitchChange={handleCheckboxChange}
                type="text"
                value={formData.btc.address.address}
                switchValue={formData.btc.address.isActive}
                placeholder="Enter BTC address"
              />

              <CustomFormGroupWithSwitch
                label="BTC OMNI Address"
                inputName="btc.address_omni.address"
                switchName="btc.address_omni.isActive"
                onChange={handleChange}
                onSwitchChange={handleCheckboxChange}
                type="text"
                value={formData.btc.address_omni.address}
                switchValue={formData.btc.address_omni.isActive}
                placeholder="Enter BTC OMNI address"
              />

              <CustomFormGroupWithSwitch
                label="BTC ERC20 Address"
                inputName="btc.address_erc20.address"
                switchName="btc.address_erc20.isActive"
                onChange={handleChange}
                onSwitchChange={handleCheckboxChange}
                type="text"
                value={formData.btc.address_erc20.address}
                switchValue={formData.btc.address_erc20.isActive}
                placeholder="Enter BTC ERC20 address"
              />

              <hr className="my-4" />

              {/* USDT Section */}
              <h5 className="mb-3 lao">Tether (USDT)</h5>
              <CustomFormGroupWithSwitch
                label="USDT Address"
                inputName="usdt.address.address"
                switchName="usdt.address.isActive"
                onChange={handleChange}
                onSwitchChange={handleCheckboxChange}
                type="text"
                value={formData.usdt.address.address}
                switchValue={formData.usdt.address.isActive}
                placeholder="Enter USDT address"
              />

              <CustomFormGroupWithSwitch
                label="USDT ERC20 Address"
                inputName="usdt.address_erc20.address"
                switchName="usdt.address_erc20.isActive"
                onChange={handleChange}
                onSwitchChange={handleCheckboxChange}
                type="text"
                value={formData.usdt.address_erc20.address}
                switchValue={formData.usdt.address_erc20.isActive}
                placeholder="Enter USDT ERC20 address"
              />

              <CustomFormGroupWithSwitch
                label="USDT OMNI Address"
                inputName="usdt.address_omni.address"
                switchName="usdt.address_omni.isActive"
                onChange={handleChange}
                onSwitchChange={handleCheckboxChange}
                type="text"
                value={formData.usdt.address_omni.address}
                switchValue={formData.usdt.address_omni.isActive}
                placeholder="Enter USDT OMNI address"
              />

              <div className="text-center mt-4">
                <div style={{ display: "inline-block" }}>
                  <SubmitButton loading={updateLoading} />
                </div>
              </div>
            </Form>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default DigitalWalletPage;
